<template>
  <div class="account-box">
    <img
      class="game-logo"
      :src="
        gameId && gameList.length && gameList.includes(gameId)
          ? gameList[gameId].PIC_URL
          : ''
      "
      v-if="gameId && gameList.length && gameList.includes(gameId)"
    />
    <label class="input-box box" :class="{ err: userAccountTips }">
      <span class="label">{{ letter.accountLabel }}：</span>
      <input
        v-model="userAccount"
        class="input"
        type="text"
        :class="{ err: userAccountTips }"
        @blur="judgeUserAccount()"
        :placeholder="letter.accountName"
      />
    </label>
    <p class="tips j-username-tip" v-if="userAccountTips">
      {{ userAccountTips }}
    </p>
    <label
      class="input-box password-box box"
      :class="{ err: userPasswordTips }"
    >
      <span class="label">{{ letter.passwordLabel }}：</span>
      <input
        v-model="userPassword"
        class="input"
        type="password"
        :class="[userPasswordTips ? 'err' : false, $platformClass]"
        @blur="judgeUserPassword()"
        :placeholder="letter.password"
      />
    </label>
    <p class="tips j-password-tip" v-if="userPasswordTips">
      {{ userPasswordTips }}
    </p>
    <div class="remember box">
      <div>
        <i class="goukuang j-remember-me" @click="toggleRemember">
          <i class="gou" v-show="isRemember"></i>
        </i>
        <span class="text j-remember-me" @click="toggleRemember">
          {{ letter.remember }}
        </span>
      </div>

      <a
        :href="findPwd"
        target="_blank"
        class="forget j-forget-pwd"
        v-if="!musVn"
      >
        {{ letter.forgetPwd }}
      </a>
    </div>
    <div class="btn-wrap">
      <a
        href="javascript:void(0);"
        class="btn login-btn j-login-btn"
        pointClass="j-login-btn"
        :loading="loading"
        @click="login"
      >
        <span>{{ letter.login }}</span>
        <i v-show="loading" class="loading light" style="margin-left: 1vh"></i>
      </a>
      <a
        href="javascript:void(0)"
        class="btn register-btn j-switch-regist"
        pointClass="j-switch-regist"
        @click="goRegister"
        v-if="showRegister"
      >
        {{ letter.register }}
      </a>
      <p class="tips j-request-tip request-tip">{{ loginRequestTips }}</p>
    </div>
    <div class="other-login" v-if="showThirdPart">
      <div
        v-for="(item, index) in thirdList"
        :key="index"
        class="third-box j-third-part-login"
      >
        <a
          class="login-type"
          href="javascript:;"
          :class="`j-${item}-login-btn ${$platformClass}`"
          v-if="index < 3"
          @click="
            loginHrefJump(loginHref[item], gymcGameInVn ? '_blank' : false)
          "
        >
          <i :class="item"></i>
          <p class="name">{{ channelName[item] }}</p>
        </a>
      </div>
      <a href="javascript:void(0);" v-if="thirdList.length >= 5">
        <i class="more"></i>
        <p class="name">more</p>
      </a>
    </div>
  </div>
</template>

<script type="text/javascript">
import { CHANNEL_NAME } from '../../store/web/login.js';
import login from '../../mixins/Login.js';
import globalConfig from '../../utiles/globalConfig.js';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { reportActivityPoint } from '../../utiles/webLogin/activityPoint.js';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'accountLoginPage',
  data() {
    return {
      channelName: CHANNEL_NAME,
      showThirdPart: globalConfig.getHrefParam('noThridPart') !== '1',
      gymcGameInVn:
        globalConfig.getHrefParam('gameId') == 125 ||
        globalConfig.getHrefParam('game_id') == 125 ||
        this.$store.state.gameId == 125
      // 鬼語&越南語 显示 100d品牌
    };
  },
  computed: {
    findPwd() {
      let gameId =
        this.$store.state.gameId || globalConfig.getHrefParamUndecode('gameId');
      return getGlobalGetGotoLink({
        link: `https://pay.${mainHost}/platform/passport.html?gameId=${gameId}&appLanguage=${this.$store.state.lang}&language=${this.$store.state.lang}#/findPwd`
      });
    },
    gameList() {
      return this.$store.state.gameList;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    showRegister() {
      // 金添：不需要限制游戏，带上caller_redirect_url参数的都隐藏注册按钮
      if (globalConfig.getHrefParam('caller_redirect_url')) {
        return false;
      }
      return true;
    }
  },
  mixins: [login],
  mounted() {
    // submitGoogleRecaptcha((token)=>{
    //     this.$store.dispatch(GO_LOGIN,{
    //         token:token
    //     })
    //     .then(res=>{
    //         if(res.result){
    //             window.location.href = res.forward;
    //         }
    //     });
    // });
    // renderGoogleRecaptcha('recaptcha',GOOGLE_RECAPTCHA_KEY);
  },
  unmounted() {
    console.log('AccountLoginV3 unmounted');
  },
  methods: {
    loginHrefJump(href, target) {
      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'openThirdLoginLink',
            url: href
          },
          '*'
        );
      } else {
        window.open(href, target ? '_blank' : '_self');
      }
    },
    /** mixin login 提交前钩子 */
    beforeGoLogin() {
      reportActivityPoint('login_click', {
        gameId: this.gameId,
        eventType: 'account_login'
      });
      return true;
    },
    /** mixin login 成功后钩子 */
    afterGoLoginSuccess() {
      reportActivityPoint('login_success', {
        gameId: this.gameId,
        eventType: 'account_login'
      });
    },
    /** mixin login 失败钩子 */
    onGoLoginFail(res) {
      reportActivityPoint('login_fail', {
        gameId: this.gameId,
        eventType: 'account_login',
        eventValue: { msg: String(res?.msg || '') }
      });
      return false;
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';
</style>
